import { z } from 'zod';
import { emailSchema, passwordSchema, displayNameSchema } from './common.js';
// User validation schemas
export const voicePreferencesSchema = z.object({
    language: z.string().length(2).default('en'),
    speakingRate: z.number().min(0.5).max(2.0).default(1.0),
});
export const marketplaceSettingsSchema = z.object({
    enabled: z.boolean().default(false),
    defaultListingStatus: z
        .enum(['private', 'discoverable', 'not_for_sale'])
        .default('private'),
    searchRadiusKm: z.number().min(1).max(500).default(50),
});
export const userSettingsSchema = z.object({
    defaultInventoryId: z.string().uuid().optional(),
    voicePreferences: voicePreferencesSchema.default({}),
    marketplace: marketplaceSettingsSchema.default({}),
});
export const createUserSchema = z.object({
    email: emailSchema,
    password: passwordSchema,
    displayName: displayNameSchema,
});
export const updateUserSchema = z.object({
    displayName: displayNameSchema.optional(),
    settings: userSettingsSchema.partial().optional(),
});
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'Password is required'),
});
export const registerSchema = createUserSchema;
//# sourceMappingURL=user.js.map